module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sd-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "top": "15%",
      "left": "33%"
    }
  }, [_c('div', {
    staticClass: "form_modal"
  }, [_c('i', {
    staticClass: "close"
  }), _vm._v(" "), _c('p', {
    staticClass: "form_title"
  }, [_vm._v("发票信息")]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr"
  }, [_c('p', {
    staticClass: "error"
  }), _vm._v(" "), _c('label', {
    class: {
      'req': true
    }
  }, [_vm._v("发票类型")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.invoiceType),
      expression: "param.invoiceType"
    }],
    staticClass: "short select",
    staticStyle: {
      "-webkit-appearance": "menulist"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.param, "invoiceType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.dirtyAll(false)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("增值税普通发票")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("增值税专用发票")])])]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkInvoiceTitle
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请填写发票抬头")]), _vm._v(" "), _c('label', {
    class: {
      'req': true
    }
  }, [_vm._v("发票抬头")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.invoiceTitle),
      expression: "param.invoiceTitle"
    }],
    staticClass: "long",
    attrs: {
      "type": "text",
      "maxlength": "42"
    },
    domProps: {
      "value": (_vm.param.invoiceTitle)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.invoiceTitle = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "invoiceTitle", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkIdentifyNumber
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请填写纳税人识别号")]), _vm._v(" "), _c('label', {
    class: {
      'req': true
    }
  }, [_vm._v("纳税人识别号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.identifyNumber),
      expression: "param.identifyNumber"
    }],
    staticClass: "long",
    attrs: {
      "type": "text",
      "maxlength": "40"
    },
    domProps: {
      "value": (_vm.param.identifyNumber)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.identifyNumber = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "identifyNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkRegAddress
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请填写注册地址")]), _vm._v(" "), _c('label', {
    class: {
      'req': _vm.isZP
    }
  }, [_vm._v("注册地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.regAddress),
      expression: "param.regAddress"
    }],
    staticClass: "long",
    attrs: {
      "type": "text",
      "maxlength": "80"
    },
    domProps: {
      "value": (_vm.param.regAddress)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.regAddress = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "regAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkRegPhone
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请填写注册电话")]), _vm._v(" "), _c('label', {
    class: {
      'req': _vm.isZP
    }
  }, [_vm._v("注册电话")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.regPhone),
      expression: "param.regPhone"
    }],
    staticClass: "short",
    attrs: {
      "type": "text",
      "maxlength": "17"
    },
    domProps: {
      "value": (_vm.param.regPhone)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.regPhone = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "regPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkRegBank
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请填写开户银行名称")]), _vm._v(" "), _c('label', {
    class: {
      'req': _vm.isZP
    }
  }, [_vm._v("开户银行")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.regBank),
      expression: "param.regBank"
    }],
    staticClass: "long",
    attrs: {
      "type": "text",
      "maxlength": "42"
    },
    domProps: {
      "value": (_vm.param.regBank)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.regBank = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "regBank", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    class: {
      'invalid': !_vm.checkBankNumber
    }
  }, [_c('p', {
    staticClass: "error"
  }, [_vm._v("请填写银行账号")]), _vm._v(" "), _c('label', {
    class: {
      'req': _vm.isZP
    }
  }, [_vm._v("银行账号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.bankNumber),
      expression: "param.bankNumber"
    }],
    staticClass: "long",
    attrs: {
      "type": "text",
      "maxlength": "34"
    },
    domProps: {
      "value": (_vm.param.bankNumber)
    },
    on: {
      "blur": function($event) {
        _vm.dirty.bankNumber = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.param, "bankNumber", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form_ctr",
    staticStyle: {
      "margin-top": "-10px"
    }
  }, [_c('p', {
    staticClass: "error"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.param.haveDefault),
      expression: "param.haveDefault"
    }],
    staticStyle: {
      "margin-left": "166px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.param.haveDefault) ? _vm._i(_vm.param.haveDefault, null) > -1 : (_vm.param.haveDefault)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.param.haveDefault,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.param, "haveDefault", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.param, "haveDefault", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.param, "haveDefault", $$c)
        }
      }
    }
  }), _vm._v("设为默认\n      ")]), _vm._v(" "), _c('ul', {
    staticClass: "btn"
  }, [(_vm.type == 'add') ? _c('li', {
    on: {
      "click": _vm.addInvoice
    }
  }, [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.type == 'update') ? _c('li', {
    on: {
      "click": _vm.updateInvoice
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_vm._v("返回")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49182ec4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/addInvoice.vue
// module id = 859
// module chunks = 1